/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { Zone } from '@scenario/models/zone.model';
import { RootState } from '@store/create-store';
import { retrieveRegionsFailure, retrieveRegionsSuccess } from '@store/scenario/regions/regions-slice';

export const retrieveZonesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('regions/retrieveRegions'),
    concatMap((_action: Action) =>
      from(dependencies.regionGateway.retrieveAll()).pipe(
        map((regions: Zone[]) => retrieveRegionsSuccess(regions)),
        catchError(() => of(retrieveRegionsFailure('Fail to retrieve regions'))),
      ),
    ),
  );
